var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"800","src":_vm.dashboardUrl,"frameborder":"0","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }